import React from 'react';
import { cn } from '@/utils/cn';

export const LoadingIndicator = ({ className }: { className?: string }) => (
  <div
    className={cn('flex items-center justify-center space-x-1.5', className)}
  >
    <span className="h-4 w-5 -skew-x-12 animate-loader rounded-sm bg-primary"></span>
    <span className="animation-delay-200 h-4 w-5 -skew-x-12 animate-loader rounded-sm bg-primary"></span>
    <span className="animation-delay-400 h-4 w-5 -skew-x-12 animate-loader rounded-sm bg-primary"></span>
    <span className="animation-delay-600 h-4 w-5 -skew-x-12 animate-loader rounded-sm bg-primary"></span>
    <span className="animation-delay-800 h-4 w-5 -skew-x-12 animate-loader rounded-sm bg-primary"></span>
  </div>
);